// @flow
import styled from 'styled-components';
import { cleanWhite } from '../../colors';
import { InputTheme } from '../input';
import { MultiInputTheme } from '../multi-input';
import { ListTheme } from '../list';
import { ItemTheme } from '../item';
import { Theme as PopupTheme } from '../../popup';
import { InputTheme as InputMoleculeTheme } from '../../input';
import { FormElementTheme } from '../../form-element';
/*::
import type { Node } from 'react';
import type { InputThemeType } from '../input/theme';
import type { MultiInputThemeType } from '../multi-input/theme';
import type { ListThemeType } from '../list/theme';
import type { ItemThemeType } from '../item/theme';
import type { PopupTheme as PopupThemeType } from '../../popup';
import type { InputThemeType as InputMoleculeThemeType } from '../../input';
import type { FormElementThemeType } from '../../form-element';

export type SelectThemeType = {|
  Main: * => Node,
  InputContainer: * => Node,
  Popup: PopupThemeType,
  ScrollBox: * => Node,
  Input: InputThemeType,
  MultiInput: MultiInputThemeType,
  List: ListThemeType,
  Item: ItemThemeType,
  OthersInputContainer: * => Node,
  OthersInputFormElement: FormElementThemeType,
  OthersInput: InputMoleculeThemeType,
|};
*/

var SelectTheme
/*: SelectThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "ljrfj9-0"
  })(["position:relative;line-height:normal;"]),
  InputContainer: styled.div.withConfig({
    displayName: "theme__InputContainer",
    componentId: "ljrfj9-1"
  })([""]),
  Popup: Object.assign({}, PopupTheme, {
    Main: styled(PopupTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "ljrfj9-2"
    })(["visibility:", ";position:absolute;width:100%;background:", ";border:none;padding:0;box-shadow:", ";z-index:3;", ""], function (props) {
      return props.visible ? 'visible' : 'hidden';
    }, cleanWhite(), function (pr) {
      return typeof pr.top === 'number' ? '0px -2px 4px rgba(0, 0, 0, 0.11614)' : '0px 2px 4px rgba(0, 0, 0, 0.11614)';
    }, function (props) {
      return typeof props.top === 'number' ? "top: " + props.top + "px" : null;
    })
  }),
  ScrollBox: styled.div.withConfig({
    displayName: "theme__ScrollBox",
    componentId: "ljrfj9-3"
  })(["max-height:15.2rem;overflow-y:auto;"]),
  Input: InputTheme,
  MultiInput: MultiInputTheme,
  List: ListTheme,
  Item: ItemTheme,
  OthersInputContainer: styled.div.withConfig({
    displayName: "theme__OthersInputContainer",
    componentId: "ljrfj9-4"
  })(["padding:1rem 1rem 0;"]),
  OthersInputFormElement: FormElementTheme,
  OthersInput: InputMoleculeTheme
};
export default SelectTheme;